
import Vue from 'vue';
import { CvButton } from '@carbon/vue';

export default Vue.extend({
  name: 'RoundItemPanel',
  components: {
    CvButton,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: true,
    },
  },

  methods: {},
});
